module.exports = __webpack_public_path__ + "img/case_4.56b4261c.png";